import React from "react";
import {
  ProfileMenuPage,
  FeedbackFormPage,
  FeedbackHistoryPage,
} from "@zillout/shared-components";
import { getPubId } from "../config/env";

export const AccountProfileMenu: React.FC = () => {
  const pubId = getPubId();
  return <ProfileMenuPage pubId={pubId} />;
};

export const AccountFeedbackForm: React.FC = () => {
  const pubId = getPubId();
  return <FeedbackFormPage pubId={pubId} />;
};

export const AccountFeedbackHistory: React.FC = () => {
  const pubId = getPubId();
  return <FeedbackHistoryPage pubId={pubId} />;
};
